import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Button} from 'views/components';
import {AddCircleOutline as AddCircleOutlineIcon} from 'views/icons';
import {Translate} from 'views/module';

import AddNewContact from './AddNewContact';
import ClientContact from './ClientContact';

const ClientContacts = (props) => {
  const [isAdding, setIsAdding] = React.useState(false);

  const {
    clientData,
    clientBackend,
  } = props;

  const contacts = Object.values(clientData.contacts);

  return (
    <>
      <Stack
        spacing={2}
        sx={{
          pb: 2,
        }}
      >
        {
          contacts.map((contact, index) => {
            return (
              <ClientContact
                key={index}
                contact={contact}
                clientData={clientData}
                clientBackend={clientBackend}
              />
            );
          })
        }
        <Button
          startIcon={<AddCircleOutlineIcon />}
          onClick={() => setIsAdding(true)}
        >
          <Translate expression='client.ClientDetail.Settings.Contact.CreateNew.Action' />
        </Button>
        {
          isAdding &&
          <AddNewContact
            clientData={clientData}
            clientBackend={clientBackend}
            isEditing={isAdding}
            setIsEditing={setIsAdding}
          />
        }
      </Stack>
    </>
  );
};

ClientContacts.propTypes = {
  clientData: PropTypes.object.isRequired,
  clientBackend: PropTypes.object.isRequired,
};

export default React.memo(ClientContacts);
